export const loader = {
  START: "Loader.Start",
  start: () => {
    window.dispatchEvent(new CustomEvent(loader.START));
  },
  STOP: "Loader.Stop",
  stop: () => {
    window.dispatchEvent(new CustomEvent(loader.STOP));
  },
};
